import {
    Component,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    inject,
    DOCUMENT,
    computed,
    OnInit,
    DestroyRef,
    signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ThemeService } from '../services/theme.service';
import { UserService } from '../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticatedGuard } from '../routes/routes.guard';
import { AuthService } from '../services/authentication.service';
import { ApplicationService } from '../services/application.service';
import { BUILD_TIME } from '../services/version.service';
import { MatDialog } from '@angular/material/dialog';
import { DebugDialogComponent } from '../app/modals/debug-modal/debug-modal.component';
import { filter } from 'rxjs';
import { CategoryService } from '../services/category.service';

@Component({
    selector: 'app-root',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet, MatIconModule, MatButtonModule, MatTooltipModule, MatSlideToggleModule, RouterModule],
    host: {
        class: 'h-full block',
    },
})
export class AppComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly authGuard = inject(AuthenticatedGuard);
    protected readonly authSvc = inject(AuthService)
    protected readonly appSvc = inject(ApplicationService);
    protected readonly matDialog = inject(MatDialog);
    protected readonly document = inject<Document>(DOCUMENT);
    protected readonly themeSvc = inject(ThemeService);
    protected readonly userSvc = inject(UserService);
    protected readonly router = inject(Router);
    protected readonly categorySvc = inject(CategoryService);
    title = computed(() => {
        if (this.categorySvc.category() === 'kelly') {
            return 'Kelly Services';
        }
        else if (this.categorySvc.category() === 'contractor') {
            return 'Contractor';
        }
        else if (this.categorySvc.category() === 'volunteer') {
            return 'Volunteer';
        }
        else {
            return '';
        }
    });

    ngOnInit(): void {
        //get form version based on URL
        this.categorySvc.lookupURL();

        //subscribe to navigation changes incase URL changes
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((res: any) => {
            this.categorySvc.lookupURL();
        });

        this.userSvc.UserSubject.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((user) => {
            if (user != null) {
                this.authGuard.setIsAuthenticated(user);
                if (this.matDialog.openDialogs.length < 1) {
                    this.authSvc.startTimers(user);
                }
            }
        });
    }

    // #region Properties

    protected readonly themeMode = computed(() => this.themeSvc.currentTheme());

    // #endregion

    // #region Toggle Theme

    toggleTheme() {
        this.themeSvc.toggle();
    }

    // #endregion

    logout() {
        this.userSvc.logout(true);
    }

    debugClick() {
        this.appSvc.GetDebugInfo().subscribe({
            next: (info) => {
                if (info) {
                    info.BuildTime = BUILD_TIME;

                    this.matDialog
                        .open(DebugDialogComponent, { data: info, width: '500px', height: '300px' })
                        .afterClosed()
                        .pipe(takeUntilDestroyed(this.destroyRef))
                        .subscribe();
                }
            },
        });
    }
}
